export function mapCloudinaryAsset(data) {
  const noUnderscoreProps = ({
    public_id,
    created_at,
    secure_url,
    resource_type,
    original_url,
    original_secure_url,
    raw_transformation,
    ...rest
  }) => rest;
  return {
    ...noUnderscoreProps(data),
    publicId: data.public_id,
    createdAt: data.created_at,
    secureUrl: data.secure_url,
    resourceType: data.resource_type,
    originalUrl: data.original_url,
    originalSecureUrl: data.original_secure_url,
    rawTransformation: data.raw_transformation,
  };
}

export function extractCloudinaryImage(image, altText = null) {
  if (image?.length) {
    return {
      alt: altText ?? image[0]?.context?.custom?.alt ?? ``,
      ...mapCloudinaryAsset(image[0]),
    };
  }
  return null;
}

export function extractCloudinaryVideo(data) {
  if (data?.video?.length) {
    return {
      ...mapCloudinaryAsset(data.video[0]),
      title: data?.title,
      caption: data?.caption,
      previewImage: extractCloudinaryImage(data?.previewImage),
    };
  }
  return null;
}
